import { useTranslation } from 'react-i18next';
import { ApiDigitalWalletToken } from '../../openapi';

export function useWalletName(token: ApiDigitalWalletToken | undefined): string {
  const { t } = useTranslation();

  switch (token?.tokenRequestor) {
    case 'APPLE_PAY':
      return t('Apple Pay');
    case 'GOOGLE_PAY':
      return t('Google Pay');
    default:
      return t('Wallet');
  }
}
